import { useMemo } from 'react'

import { useTheme } from './'

import type { ThemeFactory } from './types'

export default function useThemedStylesheet(
  makeStylesheet: ThemeFactory,
): Record<string, any> {
  const theme = useTheme()

  return useMemo(() => makeStylesheet({ ...theme }), [makeStylesheet, theme])
}
